import PropTypes from 'prop-types';
import React, { createContext, useState, useEffect } from 'react';

// Constants
import { ORIGIN_TYPE_SELECTION, TypesVariableDND } from '../utils/constants';

export const DNDContext = createContext();

export const DNDContextProvider = (props) => {
  // States for form in general
  const [deletedTabs, setDeletedTabs] = useState([]);
  const [deletedSections, setDeletedSections] = useState([]);
  const [initialForm, setInitialForm] = useState([]);
  const [processId, setProcessId] = useState();

  // States for all used variables and records
  const [varArrayChange, setVarArrayChange] = useState(false);
  const [recordArrayChange, setRecordArrayChange] = useState(false);
  const [usedVars, setUsedVars] = useState([]);

  // States for the selected variable and record
  const [resetState, setResetState] = useState(false);
  const [showOriginSelector, setShowOriginSelector] = useState(false);
  // const [showQuerySql, setShowQuerySql] = useState(false);
  const [showInfSource, setShowInfSource] = useState(false);
  const [showVariableList, setshowVariableList] = useState(false);
  const [validators, setValidators] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [showUpdateRecord, setShowUpdateRecord] = useState(false);
  const [showUpdateVar, setShowUpdateVar] = useState(true);
  const [varOrRecordDeleted, setVarOrRecordDeleted] = useState(false);
  const [hasBeenSaved, setHasBeenSaved] = useState(true);
  const [showSmartMappingRules, setShowSmartMappingRules] = useState(false);

  // Empty state for the selected variable
  const emptyVariable = {
    // General
    componentTypeId: '',
    variableTypeId: '',
    name: '',
    id: '',
    databaseId: '',
    tagName: '',
    originTypeId: '',
    nameColumn: '',
    associatedAspects: '',
    defaultValue: '',
    helpMessage: '',
    informationSourceId: '',
    smartMappingRules: '',
    // querySql: '',
    dependsOn: '',
    // Configuration
    condicion: '',
    typeProcess: '',
    typeAuditable: '',
    typeCreation: '',
    typeSearch: '',
    typeSearchResult: '',
    typeRequiredCreation: '',
    typeMonitor: '',
    typeIdent: '',
    typeFilterSearch: '',
    dependentObligation: '',
    // Advance
    style: '',
    class: '',
    onChange: '',
    onClick: '',
    onBlur: '',
    onFocus: '',
    onKeyUp: '',
  };

  // Empty state for the selected record
  const emptyRecord = {
    name: '',
    tagName: '',
    layout: '',
    baseTable: '',
    smartTableFillingRules: '',
    helpMessage: '',
    isAuditable: '',
  };

  const [variable, setVariable] = useState(emptyVariable);
  const [record, setRecord] = useState(emptyRecord);

  // ------------------------------------------- //
  // -------------- Action Handlers ------------ //
  // ------------------------------------------- //

  const setEmptyVar = () => {
    let theVar = emptyVariable;
    const parsedValidators = validators?.map((elem) => {
      return { [`dinVal-${elem.value}`]: '' };
    });
    parsedValidators?.forEach((pv) => {
      // Reset all validators
      theVar = { ...theVar, ...pv };
    });
    const parsedTasks = tasks?.map((elem) => {
      return {
        [`dinTask-m-${elem.value}`]: '',
        [`dinTask-r-${elem.value}`]: '',
        [`dinTask-w-${elem.value}`]: '',
        [`dinTask-ct-${elem.value}`]: '',
      };
    });
    parsedTasks?.forEach((pt) => {
      // Reset all tasks
      theVar = { ...theVar, ...pt };
    });
    setVariable(theVar);
  };

  const setEmptyRecord = () => {
    const theRecord = emptyRecord;
    setRecord(theRecord);
  };

  // ------------------------------------------- //
  // ---------- Side Effects Handlers ---------- //
  // ------------------------------------------- //

  useEffect(() => {
    if (resetState) {
      setEmptyVar();
      setEmptyRecord();
      setResetState(false);
      setShowOriginSelector(false);
      // setShowQuerySql(false);
      setShowInfSource(false);
      setshowVariableList(false);
      setShowSmartMappingRules(false);
    }
  }, [resetState]);

  useEffect(() => {
    if (varArrayChange) {
      setEmptyVar();
    }
  }, [varArrayChange]);

  useEffect(() => {
    if (recordArrayChange) {
      setEmptyRecord();
    }
  }, [recordArrayChange]);

  useEffect(() => {
    if (
      variable.componentTypeId === TypesVariableDND.SELECT ||
      variable.componentTypeId === TypesVariableDND.RADIO_BUTTON ||
      variable.componentTypeId === TypesVariableDND.CHECKBOX
    ) {
      setShowOriginSelector(true);
    } else {
      setShowOriginSelector(false);
      setShowInfSource(false);
      setshowVariableList(false);
    }
    if (variable.originTypeId === ORIGIN_TYPE_SELECTION.INF_SOURCE) {
      setShowInfSource(true);
      setshowVariableList(true);
    } else {
      setShowInfSource(false);
      setshowVariableList(false);
    }
    if (variable.componentTypeId === TypesVariableDND.FILEUPLOAD) {
      setShowSmartMappingRules(true);
    } else {
      setShowSmartMappingRules(false);
    }
    // if (variable.originTypeId === ORIGIN_TYPE_SELECTION.QUERY_SQL) {
    //   setShowQuerySql(true);
    // } else {
    //   setShowQuerySql(false);
    // }
  }, [variable]);

  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <DNDContext.Provider
      value={{
        varArrayChange,
        usedVars,
        resetState,
        variable,
        record,
        showOriginSelector,
        showInfSource,
        showVariableList,
        validators,
        tasks,
        showUpdateRecord,
        recordArrayChange,
        deletedTabs,
        initialForm,
        varOrRecordDeleted,
        deletedSections,
        hasBeenSaved,
        processId,
        showUpdateVar,
        showSmartMappingRules,
        setInitialForm,
        setRecordArrayChange,
        setDeletedTabs,
        setDeletedSections,
        setVarOrRecordDeleted,
        setHasBeenSaved,
        setProcessId,
        setVarArrayChange,
        setUsedVars,
        setResetState,
        setVariable,
        setRecord,
        setShowOriginSelector,
        // showQuerySql,
        // setShowQuerySql,
        setShowInfSource,
        setshowVariableList,
        setValidators,
        setTasks,
        setShowUpdateRecord,
        setShowUpdateVar,
        setShowSmartMappingRules,
      }}
    >
      {props.children}
    </DNDContext.Provider>
  );
};

DNDContextProvider.propTypes = {
  children: PropTypes.node,
};
